import React from 'react'
import { Skeleton } from '@mui/material'

import { useToast } from '@hooks'
import { isLoadingCommonFilters } from '@signals'
import { BACKEND_APIS } from '@constants'
import { TitleWithPopover, AppTableSeeker } from "@components";
import {
    companyBrandColumn, reachColumn, pageProductTypeColumn, retailerColumn, bestPositionColumn,
    pageCategoryColumn, infoColumn, startEndDateColumn, imageBannerColumn, tagColumn
} from "./columns";
import {useTopBannersFilters} from "../@hooks";


export default function TopBannersTable() {

    const { data } = useTopBannersFilters()
    const { showToast } = useToast()

    if (isLoadingCommonFilters.value) return <Skeleton variant="rectangular" height={500} />
    if (!data.length) return <></>

    const columns =[
        retailerColumn(),
        imageBannerColumn(),
        ...companyBrandColumn(),
        ...infoColumn(),
        tagColumn(),
        startEndDateColumn(),
        pageCategoryColumn(),
        pageProductTypeColumn(),
        bestPositionColumn(),
        reachColumn()
    ]

    return <AppTableSeeker
        data={data}
        title={ <TitleWithPopover title="Top Banners" />}
        columns={columns}
        options={{
            onDownload: () => showToast.promiseExcel(`${BACKEND_APIS.BANNERS}/top-banners/wrapped/excel`),
        }}
    />
}